import { featureItem } from '@/mocks/homeData';

export default function FeaturedCard() {
  return (
    <article className="group rounded-lg border border-background-300 bg-background-50 overflow-hidden">
      <a href="#timeline" className="block relative w-full h-[240px] md:h-[320px] overflow-hidden bg-background-200">
        <img
          src={featureItem.cover}
          alt="黑料图文深扒长图专题封面"
          title="黑料图文内幕解析 48 小时反转时间线"
          className="w-full h-full object-cover object-top group-hover:scale-[1.03] transition-transform duration-700"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/75 via-foreground-950/10 to-transparent"></div>
        <div className="absolute top-4 left-4 flex items-center gap-2">
          <span className="h-6 px-2.5 inline-flex items-center rounded-md bg-primary-500 text-background-50 text-[11px] font-label">本期主推</span>
          <span className="h-6 px-2.5 inline-flex items-center rounded-md bg-background-50/95 text-foreground-800 text-[11px] font-label">{featureItem.tag}</span>
        </div>
        <div className="absolute inset-x-0 bottom-0 p-4 md:p-6">
          <h3 className="font-heading text-lg md:text-2xl font-bold leading-snug text-background-50">{featureItem.title}</h3>
          <div className="mt-3 flex flex-wrap items-center gap-3 text-xs text-background-50/85 font-label">
            <span className="flex items-center gap-1"><i className="ri-gallery-line"></i>{featureItem.imageCount}</span>
            <span className="flex items-center gap-1"><i className="ri-eye-line"></i>{featureItem.views}</span>
            <span className="flex items-center gap-1"><i className="ri-chat-3-line"></i>{featureItem.comments} 条评论</span>
            <span>{featureItem.time}</span>
          </div>
        </div>
      </a>
      <div className="p-4 md:p-5">
        <p className="text-sm leading-relaxed text-foreground-700 font-body">{featureItem.summary}</p>
      </div>
    </article>
  );
}